'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _episodevalue = require('./episodevalue.html');

var _episodevalue2 = _interopRequireDefault(_episodevalue);

var _episodevalue3 = require('./episodevalue.controller');

var _episodevalue4 = _interopRequireDefault(_episodevalue3);

require('./episodevalue.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var episodevalueComponent = {
  restrict: 'E',
  bindings: {},
  template: _episodevalue2.default,
  controller: _episodevalue4.default,
  controllerAs: 'vm'
};

exports.default = episodevalueComponent;


// WEBPACK FOOTER //
// ./client/app/common/admin/episodevalue/episodevalue.component.js